import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import ModalDialog from './main';
var ModalDialogWithEvents = withEvents(ModalDialog);
export { ModalDialog, ModalDialogWithEvents };
export default withMessage(ModalDialogWithEvents, 'modalDialog');